<template>
	<footer :class="{ footer: true, absolute: absolute }">
		<p class="copyright">© {{ theYear }} {{ siteName }} <span v-if="version" v-html="version" /></p>
	</footer>
</template>

<script>
import general from "./../utils/general";
export default {
	name: "Footer",
	props: {
		siteName: {
			type: String,
			default: "",
		},
		absolute: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		theYear() {
			return new Date().getFullYear();
		},
		version() {
			if (typeof lastUpdate !== "undefined" && general.isAdmin()) {
				//return "<br>The version you are seeing is from the " + general.dateFormat("jS F 'y @ H:i", lastUpdate.replace("_", " "));
			}
			if (typeof version !== "undefined") {
				return "<br>ver: " + general.dateFormat("dm", lastUpdate.replace("_", " ")) + '.' + version.substring(0, 7);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.footer {
	padding-bottom: 40px;
	position: relative;

	&.fade {
		opacity: 0.35;
	}

	.copyright {
		margin: 0;
		padding: 25px 0 70px;
		text-align: center;
		opacity: 0.5;
		font-size: 12px;
	}

	&.absolute {
		position: absolute;
		bottom: -20px;
		padding-bottom: 0px;
		width: 100%;

		.copyright {
			padding: 0;
		}
	}
}
@media screen and (min-width: 1024px) {
	.footer {
		&.absolute {
			bottom: 20px;
		}
	}
}

@media screen and (min-width: 1024px) and (max-height: 380px) {
	.footer {
		display: none;
	}
}
</style>
